export default __webpack_public_path__ + "static/media/logo.36d778a4.svg";